import 'cirrus-ui'
import './NavigationBrand'
import { NavigationBrand } from './NavigationBrand';
import { NavigationMenu } from './NavigationMenu';
import React from 'react';
import { NavigationContext } from '../contexts/NavigationContext'

export function Header() {

    const [isToggleOn, setToggleOn] = React.useState(0);

    return (
        <NavigationContext.Provider value={{
            isToggleOn,
            setToggleOn
        }}>
            <div className="header header-fixed unselectable header-animated">
                <NavigationBrand sitename="PERNC" />
                <NavigationMenu />
            </div>
        </NavigationContext.Provider>
    );

}